import {
  GET,
  POST,
  GETPDF
} from '@/axios/axios'

export const services = {
  findCustom: (param) => { // 后台查询商户
    return GET("/backend/custom/dz/findCustom", param);
  },
  reconciliationTable: (param) => { // 后台对账单列表
    return GET("/backend/reconciliationTable/dz/findReconciliationTable", param);
  },
  reconciliationExport: (param, rsType) => { // 后台对账单列表-导出
    return GETPDF("/backend/reconciliationTable/dz/findReconciliationTableExport", param, rsType);
  },
  findBillCompareList: (param) => { // 自动对账
    return GET("/backend/accountPayment/findBillCompareList", param);
  },
  updateBillCompare: (param) => { // 自动对账-操作
    return POST("/backend/accountPayment/updateBillCompare", param);
  },
  findBillCompareExport: (param, rsType) => { // 自动对账-导出
    return GETPDF("/backend/accountPayment/findBillCompareExport", param, rsType);
  },
  queryBudgetCount: (param) => { // 财务数据列表
    return GET("/backend/wxBudgetCount/queryBudgetCount", param);
  },
  queryExport: (param, rsType) => { // 财务数据列表-导出
    return GETPDF("/backend/wxBudgetCount/export", param, rsType);
  },
  budgetRecordCheck: (param) => { // 财务数据列表-三方导出数据校验
    return POST("/backend/wxBudgetCount/budgetRecordCheck", param);
  },
  agentBudgetCount: (param) => { // 代理商财务数据列表
    return GET("/backend/wxBudgetCount/queryAgentBudgetCount", param);
  },
  exportAgentCount: (param, rsType) => { // 代理商财务数据列表-导出
    return GETPDF("/backend/wxBudgetCount/exportAgentBudgetCount", param, rsType);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/statementAccount.js